// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","Footer":"Footer_cg4ra","disclaimer":"disclaimer_d1nzZ"};